// 初始化数据
const modal = {
  searchResult: [], //查询结果数据
  searchParams: {},
  total: 0, // 查询总数
  page: 1, // 当前页码
  size: 10, // 当前分页数
  tableLoading: false, // 列表loading
};
export default modal;
